{
    "name": "SFP-Tool",
    "version": "1.2.3.4",
    "new_install_prompt_erase": false,
    "builds": [
        {
            "chipFamily": "ESP32-S3",
            "parts": [
                {
                    "path": "https://s3.jonasled.de/sfp-tool/firmware.bin",
                    "offset": 0
                }
            ]
        }
    ]
}